export default __webpack_public_path__ + "static/media/XS4 Locker.abace3bf.jpg";